import { Invoice } from '@zonofi/zono-money-store';
import './invoice-details.scss';
import React from 'react';
import { Text } from '../../common';
import { InvoiceDetailsProductCard } from '../invoice-details-product-card';

interface InvoiceDetailsProps {
  invoiceDetails: Invoice;
}
export const InvoiceDetails: React.FC<InvoiceDetailsProps> = ({
  invoiceDetails,
}) => {
  return (
    <div className="invoice-details">
      {invoiceDetails?.lines?.length > 0 && (
        <Text className="invoice-details-invoiced-products font-semibold">
          {String(invoiceDetails?.lines?.length).padStart(2, '0')} PRODUCTS
          INVOICED
        </Text>
      )}
      {invoiceDetails?.lines?.map((invoiceLine, index) => (
        <InvoiceDetailsProductCard
          key={index}
          invoiceDetailsItem={invoiceLine}
        />
      ))}
    </div>
  );
};
